
export function stringifyBooleans(obj: any): any {
    if (!obj || typeof obj !== 'object') return obj;

    const result = { ...obj };
    Object.keys(result).forEach(key => {
        const val = result[key];
        if (typeof val === 'boolean') {
            result[key] = val ? "True" : "False";
        } else if (val && typeof val === 'object' && !Array.isArray(val)) {
            result[key] = stringifyBooleans(val);
        }
    });
    return result;
}


export function toBoolean(val: any): boolean {
    if (val === undefined || val === null) return false;
    if (typeof val === 'boolean') return val;
    if (typeof val === 'string') {
        const lower = val.toLowerCase();
        return lower === 'true' || lower === '1';
    }
    if (typeof val === 'number') return val === 1;
    return !!val;
}


export function formatToApiDate(date: Date = new Date()): string {
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
        `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}
